module.exports = __webpack_public_path__ + "static/media/Arrow-Primary.bd8f0462.svg";